import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IBlogListResponse, IBlogResponse, IPostMonthsResponse, IPostTagsResponse } from '../models/dashboard.models';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private http: HttpClient,
    private authService: AuthService) { }

  getBlogPostTags(): Observable<IPostTagsResponse>{
    const url = `${environment.serverUrl}blog/alltagswithpostcount`;
    return this.http.get<IPostTagsResponse>(url);
  }

  getBlogPostMonths(): Observable<IPostMonthsResponse>{
    const url = `${environment.serverUrl}blog/monthswithpostcount`;
    return this.http.get<IPostMonthsResponse>(url);
  }

  getBlogById(body: any): Observable<IBlogResponse>{
    const url = `${environment.serverUrl}blog/getbyid`;
    return this.http.post<IBlogResponse>(url, body);
  }

  getBlogsByTagId(body: any): Observable<IBlogListResponse>{
    const url = `${environment.serverUrl}blog/getbytagid`;
    return this.http.post<IBlogListResponse>(url, body);
  }

  getBlogsByMonth(body: any): Observable<IBlogListResponse>{
    const url = `${environment.serverUrl}blog/postsbymonthyear`;
    return this.http.post<IBlogListResponse>(url, body);
  }

  getMidwifeBlogs(body: any): Observable<IBlogListResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}midwife/blogs`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBlogListResponse>(url, body, httpOptions);
  }

  searchBlog(body: any): Observable<IBlogListResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}blog/search`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBlogListResponse>(url, body, httpOptions);
  }

  createBlog(body: any): Observable<IBlogResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}blog/create`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IBlogResponse>(url, body, httpOptions);
  }

  getBlogsByMidwifeId(body: any): Observable<IBlogListResponse>{
    const url = `${environment.serverUrl}blog/listformidwife`;
    return this.http.post<IBlogListResponse>(url, body);
  }
}
